import { SlotAvailabilityType } from 'app/Bookings/constants'
import { LabelAppointmentMapping } from 'app/ProviderSearch/constants'
import { getAvailabilityFilters, getAvailabilityLabels } from '../utils'

const validatedDefaultMode = (
  availabilityLabels: SlotAvailabilityType[]
): string => {
  const defaultMode = SlotAvailabilityType.ONLINE
  const hasDefault = availabilityLabels.includes(defaultMode)
  const setNewDefault = availabilityLabels.find(
    (label) => label !== defaultMode
  )

  return hasDefault ? defaultMode : setNewDefault
}

export const getAvailabilityFilter = (
  availabilityTypeId: string | string[],
  providerDetails: Provider
): {
  availabilityTypeValue: SlotAvailabilityType
  availabilityLabels: SlotAvailabilityType[]
  availabilityFilters: ProviderFilter[]
} => {
  const availabilityFilters = getAvailabilityFilters(providerDetails)

  if (!availabilityFilters) {
    const appointmentFiller = validatedDefaultMode([
      SlotAvailabilityType.ONLINE,
    ])

    return {
      availabilityTypeValue: SlotAvailabilityType[appointmentFiller],
      availabilityLabels: [],
      availabilityFilters,
    }
  }

  const availabilityLabels = getAvailabilityLabels(availabilityFilters) // ['online']

  const availabilityObject = availabilityFilters.find(
    (filter) => filter.id === availabilityTypeId
  ) // 'Online'

  // ensure default 'Online' availability value exists in provider
  // or update default value to what the provider can support, like 'In person'
  const availabilityTypeValue =
    availabilityTypeId &&
    availabilityObject?.value &&
    LabelAppointmentMapping[availabilityObject.value]

  return {
    availabilityTypeValue,
    availabilityLabels,
    availabilityFilters,
  }
}
